import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { BalanceStaff } from "./BalanceStaff";
import type { PersonBalanceDTOBase } from "./PersonBalanceDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class PersonBalanceStaff implements PersonBalanceDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly balanceId: BalanceStaff | null, public readonly personId: PersonStaff | null) {
    this.cbiServiceContext = null;
    this.balanceIdLoaded = this.balanceId != null;
    this.balanceIdCached = this.balanceId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private balanceIdLoaded: boolean;
  private balanceIdCached: BalanceStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async balanceIdLazy(): Promise<BalanceStaff> {
    if (!this.balanceIdLoaded) {
      this.balanceIdCached = await this.cbiServiceContext!.balanceService().getPersonBalanceStaffBalanceId(this.assignId);
      this.balanceIdLoaded = true;
    }
    return this.balanceIdCached!;
  }
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.balanceService().getPersonBalanceStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
